import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { findUser, modifyUser, findSetting, updateAlertSetting, listDevice, updateTermSetting } from '../_actions/user_action';

import '../css/Header.css';
import '../css/Body.css';

import {
    Box,
    Button,
    Stack,
    Grid,
    TextField,
    Typography,
    Checkbox,
    FormControlLabel,
    Modal,
} from '@mui/material';
  
// 콤보박스추가
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';

// Modal import
import CloseIcon from '@mui/icons-material/Close';

// 주소검색 - 다음
import Post from "./MobilePost";
import { getUserAccount, getIsLogin } from '../utils/session';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

function MobileSettingBasic() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userAccount = getUserAccount() || {};
    const isLogin = getIsLogin();

    const [isReady, setIsReady] = useState(false);
    const [userInfo, setUserInfo] = useState();

    useEffect(() => {
        if (!isLogin || !userAccount) {
            navigate('/mobile');
            return;
        }

        let body = {
            email: userAccount.email
        };

        console.log('findUser - body', body);
        dispatch(findUser(body)).then(response => {
            console.log('findUser', response.payload);
            
            if (response.payload.findSuccess) {
                let userInfo = response.payload.userInfo;
                if (userInfo) {
                    setUserInfo(userInfo);
                    setIsReady(true);
                }
            }
        })
        .catch((err) => console.log(err));
    }, []);

    // 기본정보 설정  Set default information - 수정
    const focusRefModifyUserCompany = useRef();
    const focusRefModifyUserAddress = useRef();
    const focusRefModifyUserAddressDetail = useRef();
    const focusRefModifyUserTel = useRef();
    const focusRefModifyUserChargeName = useRef();
    const focusRefModifyUserCellPhone1 = useRef();

    const [inputsModify, setInputsModify] = useState({
        modifyUserCompany: "",
        modifyUserAddress: "",
        modifyUserAddressDetail: "",
        modifyUserPostal: "",
        modifyUserLatitude: "",
        modifyUserLongitude: "",
        modifyUserTel: "",
        modifyUserChargeName: "",
        modifyUserCellPhone1: "",
        modifyUserCellPhone2: ""
    });

    const {
        modifyUserCompany,
        modifyUserAddress,
        modifyUserAddressDetail,
        modifyUserTel,
        modifyUserChargeName,
        modifyUserCellPhone1,
        modifyUserCellPhone2
    } = inputsModify;

    const handleChangeModify = (e) => {
        console.log(e.target.name, e.target.value);

        let regex = /^[0-9\b -]{0,13}$/;
        if (e.target.name === 'modifyUserTel') {
            if (!regex.test(e.target.value))
                return;
        }
        regex = /^[0-9\b -]{0,13}$/;
        if (e.target.name === 'modifyUserCellPhone1' || e.target.name === 'modifyUserCellPhone2') {
            if (!regex.test(e.target.value))
                return;
        }

        const { value, name } = e.target;
        setInputsModify({
            ...inputsModify,
            [name]: value
        });
    };

    useEffect(() => {
        let replaceUserPhone = '';
        // 전화번호
        if (modifyUserTel.length === 10) {
            replaceUserPhone = modifyUserTel.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserTel: replaceUserPhone
            });
        }
        if (modifyUserTel.length === 12) {
            replaceUserPhone = modifyUserTel.replace(/-/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserTel: replaceUserPhone
            });
        }
        if (modifyUserTel.length === 13) {
            replaceUserPhone = modifyUserTel.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserTel: replaceUserPhone
            });
        }
        // 휴대폰 1
        if (modifyUserCellPhone1.length === 10) {
            replaceUserPhone = modifyUserCellPhone1.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserCellPhone1: replaceUserPhone
            });
        }
        if (modifyUserCellPhone1.length === 13) {
            replaceUserPhone = modifyUserCellPhone1.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserCellPhone1: replaceUserPhone
            });
        }
        // 휴대폰 2
        if (modifyUserCellPhone2.length === 10) {
            replaceUserPhone = modifyUserCellPhone2.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserCellPhone2: replaceUserPhone
            });
        }
        if (modifyUserCellPhone2.length === 13) {
            replaceUserPhone = modifyUserCellPhone2.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            setInputsModify({
                ...inputsModify,
                modifyUserCellPhone2: replaceUserPhone
            });
        }
    }, [inputsModify, modifyUserTel, modifyUserCellPhone1, modifyUserCellPhone2]);

    // 기본정보 설정 수정 Modal
    const [modifyOpen, setModifyOpen] = useState(false);
    const handleModifyOpen = (e) => {
        setEnroll_address({
            ...enroll_address,
            address: userInfo.address,
            postal: userInfo.postal,
            latitude: userInfo.latitude,
            longitude: userInfo.longitude
        });
        setInputsModify({
            modifyUserCompany: userInfo.company,
            modifyUserTel: userInfo.tel,
            modifyUserAddress: userInfo.address,
            modifyUserAddressDetail: userInfo.addressDetail,
            modifyUserPostal: userInfo.postal,
            modifyUserLatitude: userInfo.latitude,
            modifyUserLongitude: userInfo.longitude,
            modifyUserChargeName: userInfo.chargeName,
            modifyUserCellPhone1: userInfo.cellPhone1,
            modifyUserCellPhone2: userInfo.cellPhone2
        });
        setModifyOpen(true);
    };
    const handleModifyClose = () => setModifyOpen(false);

    // 주소검색
    const [enroll_address, setEnroll_address] = useState({
        address: '',
        postal: '',
        latitude: '',
        longitude: ''
    });

    const [popup, setPopup] = useState(false);

    const handleInput = (e) => {
        setEnroll_address({
            ...enroll_address,
            [e.target.name]: e.target.value
        });
    };

    const handleComplete = (data) => {
        setPopup(!popup);
        console.log('handleComplete', data);
    };

    const handleModifySubmit = (e) => {
        e.preventDefault();
        
        let modify_key = "";
        let modify_errors = "";

        const changeUser = {
            company: modifyUserCompany,
            tel: modifyUserTel,
            address: enroll_address.address, // modifyUserAddress,
            addressDetail: modifyUserAddressDetail,
            chargeName: modifyUserChargeName,
            cellPhone1: modifyUserCellPhone1
        };

        for (var key in changeUser) {
            modify_errors = "";

            if (changeUser[key].length === 0 || changeUser[key] === undefined) {
                modify_key = key;

                if (key === 'company') {
                    modify_errors = "[상호]가 없습니다.";
                } else if (key === 'tel') {
                    modify_errors = "[전화번호]가 없습니다.";
                } else if (key === 'address') {
                    modify_errors = "[주소]가 없습니다. [주소검색]을 이용하여 입력해주세요.";
                } else if (key === 'chargeName') {
                    modify_errors = "[담당자]가 없습니다.";
                } else if (key === 'cellPhone1') {
                    modify_errors = "[휴대폰 1]이 없습니다.";
                } else if (key === 'cellPhone2') {
                    // modify_errors = "[휴대폰 2]가 없습니다."; // 휴대폰 1만 입력해도 된다.
                }
            }

            if (modify_errors.length > 1)
                break;
        }

        if (modify_errors.length > 1) {
            alert(modify_errors);

            if (modify_key === 'company') {
                focusRefModifyUserCompany.current.focus();
            } else if (modify_key === 'tel') {
                focusRefModifyUserTel.current.focus();
            } else if (modify_key === 'address') {
                focusRefModifyUserAddress.current.focus();
            } else if (modify_key === 'chargeName') {
                focusRefModifyUserChargeName.current.focus();
            } else if (modify_key === 'cellPhone1') {
                focusRefModifyUserCellPhone1.current.focus();
            }

            return;
        }

        // 상호
        if (modifyUserCompany.length < 2 || modifyUserCompany.length > 30) {
            modify_errors = "2글자 이상 30글자 미만으로 입력해주세요.";
            alert(modify_errors);
            focusRefModifyUserCompany.current.focus();
            return;
        }

        // 전화번호

        // 주소

        // 담당자
        if (modifyUserChargeName.length < 2 || modifyUserChargeName.length > 30) {
            modify_errors = "2글자 이상 30글자 미만으로 입력해주세요.";
            alert(modify_errors);
            focusRefModifyUserChargeName.current.focus();
            return;
        }

        // 휴대폰 1

        let body = {
            email: userInfo.email,
            company: modifyUserCompany,
            tel: modifyUserTel,
            address: enroll_address.address,
            addressDetail: modifyUserAddressDetail,
            postal: enroll_address.postal,
            latitude: enroll_address.latitude,
            longitude: enroll_address.longitude,
            chargeName: modifyUserChargeName,
            cellPhone1: modifyUserCellPhone1,
            cellPhone2: modifyUserCellPhone2
        };

        let modify_msg = "";

        console.log('findUser', body);
        dispatch(findUser(body)).then(response => {
            if (response.payload.findSuccess) {
                let userInfo = response.payload.userInfo;
                if (userInfo.accountActive === "Y") {
                    console.log('modifyUser', body);
                    dispatch(modifyUser(body)).then(response => {
                        if (response.payload.modifySuccess) {
                            modify_msg = "[" + userInfo.email + " (" + userAccount.company + ")] 기본정보 설정 수정 되었습니다.";
                            alert(modify_msg);
                            window.location.replace('/Setting');
                        }
                    });
                }
            }
        });
    };

    // userInfo 준비 전까지 로딩 표시
    if (!isReady || !userInfo) {
        return (
            <Box sx={{ width: '100%', px: 2, py: 4, textAlign: 'center' }}>
                <Typography>Loading...</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%', px: 2, py: 1 }}>
            {/* 1. 기본 정보 출력 */}
            <Stack spacing={2}>
                <Grid container spacing={1}>
                    {[
                        ['상호', userInfo.company],
                        ['주소', userInfo.address],
                        ['상세주소', userInfo.addressDetail],
                        ['전화번호', userInfo.tel],
                        ['담당자', userInfo.chargeName],
                        ['휴대폰1', userInfo.cellPhone1],
                        ['휴대폰2', userInfo.cellPhone2],
                    ].map(([label, val], i) => (
                        <Grid item xs={12} sm={6} key={i}>
                            <Typography variant="caption" color="textSecondary">{label}</Typography>
                            <Typography variant="body1">{val || '-'}</Typography>
                        </Grid>
                    ))}
                </Grid>
        
                <Button
                    variant="contained"
                    fullWidth
                    onClick={handleModifyOpen}
                    sx={{ backgroundColor: '#4e82eb', color:'white' }}
                >
                    정보 수정
                </Button>
            </Stack>
        
            {/* 2. 수정용 Modal */}
            <Modal
                open={modifyOpen}
                onClose={handleModifyClose}
                disableScrollLock
            >
            <Box
                sx={{
                    width: { xs: 'calc(100vw - 2px)', sm: 600 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',        // 화면 전체 높이
                    p: 2,                   // 주변 여백
                    boxSizing: 'border-box',
                }}
            >
                <Box
                    sx={{
                        width: { xs: 'calc(100vw - 32px)', sm: 600 },     // 모바일은 화면 폭 - 32px, 태블릿 이상은 600px
                        maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }, // 모바일 높이도 화면 - 32px
                        boxSizing: 'border-box',                           // padding 포함 계산
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 3,
                        overflowY: 'auto',                                 // 세로 스크롤 허용
                    }}
                >
                <Stack spacing={2}>
                    <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                        <Typography variant="h6">기본정보 수정</Typography>
                        <CloseIcon onClick={handleModifyClose} sx={{ cursor:'pointer' }} />
                    </Box>
        
                    {/* 폼 */}
                    <TextField
                        label="아이디"
                        value={userInfo.email}
                        InputProps={{ readOnly: true }}
                        fullWidth size="small"
                    />
                    <TextField
                        label="상호"
                        name="modifyUserCompany"
                        value={inputsModify.modifyUserCompany}
                        onChange={handleChangeModify}
                        fullWidth size="small"
                    />
        
                    {/* 주소검색 */}
                    <Box sx={{ display:'flex', gap:1 }}>
                        <TextField
                            label="주소"
                            value={enroll_address.address || userInfo.address}
                            InputProps={{ readOnly: true }}
                            fullWidth size="small"
                        />
                        <Button size="small" onClick={()=>setPopup(true)}>주소검색</Button>
                    </Box>
        
                    <TextField
                        label="상세주소"
                        name="modifyUserAddressDetail"
                        value={inputsModify.modifyUserAddressDetail}
                        onChange={handleChangeModify}
                        fullWidth size="small"
                    />
        
                    <TextField
                        label="전화번호"
                        name="modifyUserTel"
                        value={inputsModify.modifyUserTel}
                        onChange={handleChangeModify}
                        fullWidth size="small"
                    />
                    <TextField
                        label="담당자"
                        name="modifyUserChargeName"
                        value={inputsModify.modifyUserChargeName}
                        onChange={handleChangeModify}
                        fullWidth size="small"
                    />
                    <TextField
                        label="휴대폰1"
                        name="modifyUserCellPhone1"
                        value={inputsModify.modifyUserCellPhone1}
                        onChange={handleChangeModify}
                        fullWidth size="small"
                    />
                    <TextField
                        label="휴대폰2"
                        name="modifyUserCellPhone2"
                        value={inputsModify.modifyUserCellPhone2}
                        onChange={handleChangeModify}
                        fullWidth size="small"
                    />
        
                    {/* 주소검색 팝업 */}
                    {popup && (
                        <Post
                            address={enroll_address}
                            setaddress={setEnroll_address}
                            onClose={handleComplete}
                        />
                    )}
        
                    {/* action buttons */}
                    <Stack
                        direction={{ xs:'column', sm:'row' }}
                        spacing={1}
                        justifyContent="flex-end"
                    >
                        <Button
                            variant="contained"
                            onClick={handleModifySubmit}
                            sx={{ backgroundColor:'#4e82eb', color:'white' }}
                        >
                            수정
                        </Button>
                        <Button variant="outlined" onClick={handleModifyClose}>
                            취소
                        </Button>
                    </Stack>
                </Stack>
                </Box>
            </Box>
            </Modal>
        </Box>
    );
}

export default MobileSettingBasic;
